<template>
  <div style="margin-top: 10px">
    <!-- BDCOM GPON -->
    <div
      class="chart_row_two text-white"
      v-if="rtlData && Object.keys(rtlData).length > 0"
    >
      <div class="p-4 chart_row_one_card">
        <div class="d-flex">
          <p
            class="text-center p-0 m-0"
            style="font-size: 25px; line-height: 80px"
          >
            Total Onu Status
            <span
              v-if="rtlData.VendorID != 'N/A'"
              class="inline-block bg-success rounded-circle"
              style="
                height: 1rem;
                width: 1rem;
                display: inline-block;
                margin-right: 0.25rem;
              "
            ></span>
            <span
              v-else
              class="inline-block bg-danger rounded-circle"
              style="
                height: 1rem;
                width: 1rem;
                display: inline-block;
                margin-right: 0.25rem;
              "
            ></span>
            <sup class="text-xs">{{ portNumber }}</sup>
          </p>
        </div>

        <div
          class="row"
          v-if="onuStatus && rtlData && Object.keys(rtlData).length > 0"
        >
          <div class="active_services">
            <div>
              <div class="d-flex align-items-center">
                <div
                  class="rounded"
                  style="height: 50px; width: 50px; background-color: dimgrey"
                ></div>
                <div class="p-2">
                  <p class="m-0">Distance</p>
                  <p
                    class="m-0"
                    style="font-size: 14px; color: greenyellow !important"
                  >
                    {{ rtlData.Distance }}
                  </p>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <div
                  class="rounded"
                  style="height: 50px; width: 50px; background-color: dimgrey"
                ></div>
                <div class="p-2">
                  <p class="m-0">Mac Address</p>
                  <p
                    class="m-0"
                    style="font-size: 14px; color: greenyellow !important"
                  >
                    {{ rtlData.Serial_number }}
                  </p>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <div
                  class="rounded"
                  style="height: 50px; width: 50px; background-color: dimgrey"
                ></div>
                <div class="p-2">
                  <p class="m-0">Vendor ID</p>
                  <p
                    class="m-0"
                    style="font-size: 14px; color: greenyellow !important"
                  >
                    {{ rtlData.VendorID }}
                  </p>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <div
                  class="rounded"
                  style="height: 50px; width: 50px; background-color: dimgrey"
                ></div>
                <div class="p-2">
                  <p class="m-0">Model ID</p>
                  <p
                    class="m-0"
                    style="font-size: 14px; color: greenyellow !important"
                  >
                    {{ rtlData.ModelID }}
                  </p>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <div
                  class="rounded"
                  style="height: 50px; width: 50px; background-color: dimgrey"
                ></div>
                <div class="p-2">
                  <p class="m-0">Onu Type</p>
                  <p
                    class="m-0"
                    style="font-size: 14px; color: greenyellow !important"
                  >
                    {{ rtlData.Applied_onutype_template }}
                  </p>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <div
                  class="rounded"
                  style="height: 50px; width: 50px; background-color: dimgrey"
                ></div>
                <div class="p-2">
                  <p class="m-0">Online Duration</p>
                  <p
                    class="m-0"
                    style="font-size: 14px; color: greenyellow !important"
                  >
                    {{ rtlData.Online_Duration }}
                  </p>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <div
                  class="rounded"
                  style="height: 50px; width: 50px; background-color: dimgrey"
                ></div>
                <div class="p-2">
                  <p class="m-0">Current Time</p>
                  <p
                    class="m-0"
                    style="font-size: 14px; color: greenyellow !important"
                  >
                    {{ rtlData.Current_time }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-else>
          <Skalaton />
        </div>
      </div>

      <div class="p-4 d-flex flex-column chart_row_two_card">
        <div
          class="w-100 d-flex align-items-center justify-content-center position-relative"
        >
          <DonutChart
            :chartData="donutchartDataMiddle"
            :donutchartOptions="chartOptions"
            chartWidth="300px"
            chartHeight="300px"
            cutoutSize="80%"
            centerText=""
          />
          <div class="centered_text_donought_chart">
            <p class="p-0 m-0 text-center" style="font-size: 20px">
              {{ description }}
            </p>
            <p
              class="p-2 m-0 text-center text-xs"
              style="font-weight: 600; margin-top: -13px !important"
            >
              dBm
            </p>
          </div>
        </div>

        <div
          class="d-flex flex-grow-1 p-5 align-items-center justify-content-center"
          style="height: 190px"
        >
          <div
            class="w-50 d-flex flex-column align-items-start"
            style="border-right: 1px solid #80808071; padding-right: 10px"
          >
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• Temperature:</strong
              >
              {{ temperatureOnu || "N/A" }} °C
            </p>
          </div>

          <div
            class="w-50 d-flex flex-column align-items-start"
            style="padding-left: 10px"
          >
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• Last Disconnect Reason:</strong
              >
              <br />
              {{ lastDeregReason || "N/A" }}
            </p>
          </div>
        </div>
      </div>

      <div class="p-4 chart_row_one_card">
        <div class="d-flex flex-column flex-md-row my-4">
          <div class="w-md-50 d-flex align-items-center">
            <div>
              <DonutChart
                :chartData="donutchartData"
                :donutchartOptions="chartOptions"
                chartWidth="100px"
                chartHeight="100px"
                cutoutSize="80%"
              />
            </div>

            <div class="d-flex align-items-center mt-2 mt-lg-0 ml-3">
              <p class="text-center p-0 m-0" style="font-size: 60px">
                {{ rtlData?.Deactivation_Logs?.length }}
              </p>
              <div class="ml-2" style="color: gray; font-weight: 600">
                <p class="p-0 m-0">Total</p>
                <span class="p-0 m-0">Up Down List </span>
              </div>
            </div>
          </div>

          <div class="w-md-50 d-flex align-items-center">
            <div
              style="border-right: 1px solid #80808071; width: 33.3%"
              v-for="(item, index) in rtlData.Deactivation_Reason_Summary"
              :key="index"
            >
              <p
                class="text-center p-0 m-0"
                style="font-size: 30px; font-family: 600"
              >
                {{ item?.Count }}
              </p>
              <p
                class="text-center"
                style="
                  color: greenyellow !important;
                  font-weight: 600;
                  margin-top: -10px !important;
                "
              >
                {{ item?.Deactive_Reason
    ? item.Deactive_Reason.slice(0, 10) + '..'
    : '' 
}}

              </p>
            </div>
          </div>
        </div>

        <div class="d-flex mt-3">
          <hr class="flex-grow-1 me-2" />
          <span style="font-size: 15px">Deactive Logs</span>
          <hr class="flex-grow-1 ml-2" />
        </div>
        <div
          class="active_services mt-2"
          v-if="rtlData && Object.keys(rtlData).length > 0"
        >
          <div
            v-for="item in rtlData?.Deactivation_Logs?.slice(0, 6)"
            :key="item"
          >
            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">{{ item.Deactive_Reason }}</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  • Active Time ({{ item.Active_Time }})
                </p>
                <p class="m-0" style="font-size: 14px; color: red !important">
                  • Deactive Time ({{ item.Deactive_Time }})
                </p>
              </div>
            </div>
          </div>

          <button
            class="btn btn-secondery bg-light w-40 btn-xs mt-3 d-flex justify-content-center align-items-center text-center"
            @click="$emit('logs-popup-open')"
          >
            See More
          </button>
        </div>
        <div class="mt-2" v-else>
          <Skalaton />
        </div>
      </div>
    </div>

    <!-- AVIES EPON -->
    <div
      class="chart_row_three text-white"
      v-else-if="rtlEponData && Object.keys(rtlEponData).length > 0"
    >
      <div class="p-4 chart_row_one_card">
        <div class="d-flex">
          <p
            class="text-center p-0 m-0"
            style="font-size: 25px; line-height: 80px"
          >
            Total Onu Status
            <span
              v-if="rtlEponData?.basic_info?.data?.status == 'Online'"
              class="inline-block bg-success rounded-circle"
              style="
                height: 1rem;
                width: 1rem;
                display: inline-block;
                margin-right: 0.25rem;
              "
            ></span>
            <span
              v-else
              class="inline-block bg-danger rounded-circle"
              style="
                height: 1rem;
                width: 1rem;
                display: inline-block;
                margin-right: 0.25rem;
              "
            ></span>
            <sup class="text-xs">{{ portNumber }}</sup>
          </p>
        </div>

        <div
          class="row"
          v-if="onuStatus && rtlEponData && Object.keys(rtlEponData).length > 0"
        >
          <div class="active_services">
            <div>
              <div class="d-flex align-items-center">
                <div
                  class="rounded"
                  style="height: 50px; width: 50px; background-color: dimgrey"
                ></div>
                <div class="p-2">
                  <p class="m-0">Onu Name</p>
                  <p
                    class="m-0"
                    style="font-size: 14px; color: greenyellow !important"
                  >
                    {{ rtlEponData?.basic_info?.data?.onu_name }}
                  </p>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <div
                  class="rounded"
                  style="height: 50px; width: 50px; background-color: dimgrey"
                ></div>
                <div class="p-2">
                  <p class="m-0">Distance</p>
                  <p
                    class="m-0"
                    style="font-size: 14px; color: greenyellow !important"
                  >
                    {{ rtlEponData?.basic_info?.data?.distance }}
                  </p>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <div
                  class="rounded"
                  style="height: 50px; width: 50px; background-color: dimgrey"
                ></div>
                <div class="p-2">
                  <p class="m-0">Mac Address</p>
                  <p
                    class="m-0"
                    style="font-size: 14px; color: greenyellow !important"
                  >
                    {{ rtlEponData?.basic_info?.data?.macaddr }}
                  </p>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <div
                  class="rounded"
                  style="height: 50px; width: 50px; background-color: dimgrey"
                ></div>
                <div class="p-2">
                  <p class="m-0">Software Version</p>
                  <p
                    class="m-0"
                    style="font-size: 14px; color: greenyellow !important"
                  >
                    {{ rtlEponData?.basic_info?.data?.ctcver }}
                  </p>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <div
                  class="rounded"
                  style="height: 50px; width: 50px; background-color: dimgrey"
                ></div>
                <div class="p-2">
                  <p class="m-0">Extmodel</p>
                  <p
                    class="m-0"
                    style="font-size: 14px; color: greenyellow !important"
                  >
                    {{ rtlEponData?.basic_info?.data?.extmodel }}
                  </p>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <div
                  class="rounded"
                  style="height: 50px; width: 50px; background-color: dimgrey"
                ></div>
                <div class="p-2">
                  <p class="m-0">Vendor</p>
                  <p
                    class="m-0"
                    style="font-size: 14px; color: greenyellow !important"
                  >
                    {{ rtlEponData?.basic_info?.data?.vendor }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-else>
          <Skalaton />
        </div>
      </div>

      <div class="p-4 d-flex flex-column chart_row_two_card">
        <div
          class="w-100 d-flex align-items-center justify-content-center position-relative"
        >
          <DonutChart
            :chartData="donutchartDataMiddle"
            :donutchartOptions="chartOptions"
            chartWidth="300px"
            chartHeight="300px"
            cutoutSize="80%"
            centerText=""
          />
          <div class="centered_text_donought_chart">
            <p class="p-0 m-0 text-center" style="font-size: 20px">
              {{
                rtlEponData?.optical_diagnose?.data?.receive_power.split(
                  "dBm"
                )[0]
              }}
            </p>
            <p
              class="p-2 m-0 text-center text-xs"
              style="font-weight: 600; margin-top: -13px !important"
            >
              Receive Power
            </p>
          </div>
        </div>

        <div
          class="d-flex flex-grow-1 align-items-center justify-content-center"
          style="height: 190px"
        >
          <div
            class="w-50 d-flex flex-column align-items-start"
            style="border-right: 1px solid #80808071; padding-right: 10px"
          >
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• Work Temperature:</strong
              >
              {{
                rtlEponData?.optical_diagnose?.data?.work_temprature ||
                "N/A"
              }}
            </p>
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• Work Voltage:</strong
              >
              {{
                rtlEponData?.optical_diagnose?.data?.work_voltage || "N/A"
              }}
            </p>
          </div>

          <div
            class="w-50 d-flex flex-column align-items-start"
            style="padding-left: 10px"
          >
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• Transmit Bias:</strong
              >
              {{
                rtlEponData?.optical_diagnose?.data?.transmit_bias || "N/A"
              }}
            </p>
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• Transmit Power:</strong
              >
              {{
                rtlEponData?.optical_diagnose?.data?.transmit_power || "N/A"
              }}
            </p>
          </div>
        </div>
      </div>

      <div class="p-4 chart_row_one_card">
        <div class="d-flex flex-column flex-md-row my-4">
          <div class="w-md-50 d-flex align-items-center">
            <div>
              <DonutChart
                :chartData="donutchartData"
                :donutchartOptions="chartOptions"
                chartWidth="100px"
                chartHeight="100px"
                cutoutSize="80%"
              />
            </div>

            <div class="d-flex align-items-center mt-2 mt-lg-0 ml-3">
              <p class="text-center p-0 m-0" style="font-size: 60px">
                {{ rtlEponData?.upldown_logs?.length }}
              </p>
              <div class="ml-2" style="color: gray; font-weight: 600">
                <p class="p-0 m-0">Total</p>
                <span class="p-0 m-0">Up Down List </span>
              </div>
            </div>
          </div>

          <div class="w-md-50 d-flex align-items-center">
            <div
              style="border-right: 1px solid #80808071; width: 33.3%"
              v-for="(value, key) in rtlEponData?.upldown_logs_count"
              :key="key"
            >
              <p
                class="text-center p-0 m-0"
                style="font-size: 30px; font-family: 600"
              >
                {{ value }}
              </p>
              <p
                class="text-center p-1"
                style="
                  color: greenyellow !important;
                  font-weight: 600;
                  margin-top: -10px !important;
                  margin: 5px !important;
                "
              >
                {{ key }}
              </p>
            </div>
          </div>
        </div>

        <div class="d-flex mt-3">
          <hr class="flex-grow-1 me-2" />
          <span style="font-size: 15px">Deactive Logs</span>
          <hr class="flex-grow-1 ml-2" />
        </div>
        <div
          class="active_services mt-2"
          v-if="rtlEponData && Object.keys(rtlEponData).length > 0"
        >
          <div
            v-for="item in rtlEponData?.upldown_logs?.slice(0, 6)"
            :key="item"
          >
            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">{{ item.status }}</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  • Date ({{ item.date }})
                </p>
              </div>
            </div>
          </div>

          <button
            class="btn btn-secondery bg-light w-60 btn-xs mt-3 d-flex justify-content-center align-items-center text-center"
            @click="$emit('logs-popup-open')"
          >
            See More
          </button>
        </div>
        <div class="mt-2" v-else>
          <Skalaton />
        </div>
      </div>
    </div>

    <!-- BDCOM EPON -->
    <div
      v-else-if="rtlBdcomEponData && (rtlBdcomEponData.ok !== false) && (rtlBdcomEponData.device || rtlBdcomEponData.parsedData || (rtlBdcomEponData.interfaceData && rtlBdcomEponData.interfaceData.length > 0) || (rtlBdcomEponData.data && rtlBdcomEponData.data.length > 0))"
      class="chart_row_three text-white"
    >
      <!-- Device Information Card -->
      <div class="p-4 chart_row_one_card">
        <div class="d-flex">
          <p
            class="text-center p-0 m-0"
            style="font-size: 25px; line-height: 80px"
          >
            BDCOM EPON ONU Status
            <span
              v-if="rtlBdcomEponData.device"
              class="inline-block bg-success rounded-circle"
              style="
                height: 1rem;
                width: 1rem;
                display: inline-block;
                margin-right: 0.25rem;
              "
            ></span>
            <span
              v-else
              class="inline-block bg-danger rounded-circle"
              style="
                height: 1rem;
                width: 1rem;
                display: inline-block;
                margin-right: 0.25rem;
              "
            ></span>
            <sup class="text-xs">{{ portNumber }}</sup>
          </p>
        </div>

        <!-- Device Info -->
        <div class="row" v-if="rtlBdcomEponData && rtlBdcomEponData.device">
          <div class="active_services">
            <div>
              <div class="d-flex align-items-center">
                <div
                  class="rounded"
                  style="height: 50px; width: 50px; background-color: dimgrey"
                ></div>
                <div class="p-2">
                  <p class="m-0">OLT Name</p>
                  <p
                    class="m-0"
                    style="font-size: 14px; color: greenyellow !important"
                  >
                    {{ rtlBdcomEponData.device.olt_name || "N/A" }}
                  </p>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <div
                  class="rounded"
                  style="height: 50px; width: 50px; background-color: dimgrey"
                ></div>
                <div class="p-2">
                  <p class="m-0">OLT IP</p>
                  <p
                    class="m-0"
                    style="font-size: 14px; color: greenyellow !important"
                  >
                    {{ rtlBdcomEponData.device.olt_ip || "N/A" }}
                  </p>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <div
                  class="rounded"
                  style="height: 50px; width: 50px; background-color: dimgrey"
                ></div>
                <div class="p-2">
                  <p class="m-0">OLT Port</p>
                  <p
                    class="m-0"
                    style="font-size: 14px; color: greenyellow !important"
                  >
                    {{ rtlBdcomEponData.device.olt_port || "N/A" }}
                  </p>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <div
                  class="rounded"
                  style="height: 50px; width: 50px; background-color: dimgrey"
                ></div>
                <div class="p-2">
                  <p class="m-0">OLT ID</p>
                  <p
                    class="m-0"
                    style="font-size: 14px; color: greenyellow !important"
                  >
                    {{ rtlBdcomEponData.device.oltid || "N/A" }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-else-if="onuRealtimeLoader">
          <Skalaton />
        </div>
        <div class="row" v-else>
          <div class="active_services">
            <p style="color: #ccc; text-align: center; padding: 20px;">
              No device information available
            </p>
          </div>
        </div>
      </div>

      <!-- ONU Information Card -->
      <div class="p-4 d-flex flex-column chart_row_two_card">
        <div
          class="w-100 d-flex align-items-center justify-content-center position-relative"
        >
          <DonutChart
            :chartData="donutchartDataMiddle"
            :donutchartOptions="chartOptions"
            chartWidth="300px"
            chartHeight="300px"
            cutoutSize="80%"
            centerText=""
          />
          <div class="centered_text_donought_chart">
            <p class="p-0 m-0 text-center" style="font-size: 20px">
              {{ getReceivedPower(rtlBdcomEponData) || description || "N/A" }}
            </p>
            <p
              class="p-2 m-0 text-center text-xs"
              style="font-weight: 600; margin-top: -13px !important"
            >
              Received Power (dBm)
            </p>
          </div>
        </div>

        <div
          class="d-flex flex-grow-1 align-items-center justify-content-center"
          style="height: 190px"
        >
          <div
            class="w-50 d-flex flex-column align-items-start"
            style="border-right: 1px solid #80808071; padding-right: 10px"
          >
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• Operating Temperature:</strong
              >
              {{
                getParsedValue(rtlBdcomEponData.parsedData, 'operating temperature(degree)') || temperatureOnu || "N/A"
              }} °C
            </p>
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• Supply Voltage:</strong
              >
              {{
                getParsedValue(rtlBdcomEponData.parsedData, 'supply voltage(V)') || "N/A"
              }} V
            </p>
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• Bias Current:</strong
              >
              {{
                getParsedValue(rtlBdcomEponData.parsedData, 'bias current(mA)') || "N/A"
              }} mA
            </p>
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• Transmitted Power:</strong
              >
              {{
                getParsedValue(rtlBdcomEponData.parsedData, 'transmitted power(DBm)') || "N/A"
              }} dBm
            </p>
          </div>

          <div
            class="w-50 d-flex flex-column align-items-start"
            style="padding-left: 10px"
          >
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• Last Disconnect Reason:</strong
              >
              <br />
              {{ lastDeregReason || "N/A" }}
            </p>
          </div>
        </div>
      </div>

      <!-- ONU Details Card -->
      <div class="p-4 chart_row_one_card">
        <div class="d-flex mt-3">
          <hr class="flex-grow-1 me-2" />
          <span style="font-size: 15px">ONU Details</span>
          <hr class="flex-grow-1 ml-2" />
        </div>
        <div
          class="active_services mt-2"
          v-if="filteredBdcomEponData && filteredBdcomEponData.length > 0"
          style="max-height: 400px; overflow-y: auto"
        >
          <div
            v-for="item in filteredBdcomEponData"
            :key="item.key"
            class="d-flex align-items-center mb-2"
          >
            <div
              class="rounded"
              style="height: 50px; width: 50px; background-color: dimgrey"
            ></div>
            <div class="p-2">
              <p class="m-0" style="font-size: 12px; color: #ccc">{{ item.key }}</p>
              <p
                class="m-0"
                style="font-size: 14px; color: greenyellow !important"
              >
                {{ item.value || "N/A" }}
              </p>
            </div>
          </div>
        </div>
        <div v-else class="mt-2">
          <Skalaton />
        </div>
      </div>
    </div>

    <!-- CDATA EPON -->
    <div
      v-else-if="rtlCdataData && Object.keys(rtlCdataData).length > 0"
    >
      <div class="p-4 chart_row_one_card">
        <div class="d-flex">
          <p
            class="text-center p-0 m-0"
            style="font-size: 25px; line-height: 80px"
          >
            Total Onu Status
            <span
              v-if="rtlCdataData?.parsed?.link_status === 'up'"
              class="inline-block bg-success rounded-circle"
              style="
                height: 1rem;
                width: 1rem;
                display: inline-block;
                margin-right: 0.25rem;
              "
            ></span>
            <span
              v-else
              class="inline-block bg-danger rounded-circle"
              style="
                height: 1rem;
                width: 1rem;
                display: inline-block;
                margin-right: 0.25rem;
              "
            ></span>
            <sup class="text-xs">{{ portNumber }}</sup>
          </p>
        </div>

        <div
          class="d-flex flex-wrap w-100"
          v-if="onuStatus && rtlCdataData && Object.keys(rtlCdataData).length > 0"
        >
          <div
            class="d-flex align-items-center m-2 p-2 flex-fill"
            v-for="(value, key) in rtlCdataData.parsed"
            :key="key"
            style="
              min-width: 250px;
              max-width: 300px;
              background-color: #0c1c35;
              border-radius: 8px;
            "
          >
            <div
              class="rounded"
              style="height: 50px; width: 50px; background-color: dimgrey"
            ></div>
            <div class="p-2">
              <p class="m-0 text-capitalize">{{ key.replaceAll("_", " ") }}</p>
              <p
                class="m-0"
                style="font-size: 14px; color: greenyellow !important"
              >
                {{ value || "N/A" }}
              </p>
            </div>
          </div>
        </div>

        <div class="row" v-else>
          <Skalaton />
        </div>
      </div>
    </div>

    <!-- CDATA CLOUDE EPON -->
    <div
      v-else-if="rtlCloudeData && Object.keys(rtlCloudeData).length > 0"
    >
      <EponClodeOnuStatus
        :eponClodeOnuData="rtlCloudeData"
        :portNumber="portNumber"
        :loading="onuRealtimeLoader"
      />
    </div>

    <!-- VSOL GPON -->
    <div
      v-else-if="rtlVsolData && rtlVsolData.ok"
      class="chart_row_three text-white"
    >
      <!-- Basic Information Card -->
      <div class="p-4 chart_row_one_card">
        <div class="d-flex">
          <p
            class="text-center p-0 m-0"
            style="font-size: 25px; line-height: 80px"
          >
            VSOL ONU Status
            <span
              v-if="rtlVsolData.opticalinfo"
              class="inline-block bg-success rounded-circle"
              style="
                height: 1rem;
                width: 1rem;
                display: inline-block;
                margin-right: 0.25rem;
              "
            ></span>
            <span
              v-else
              class="inline-block bg-danger rounded-circle"
              style="
                height: 1rem;
                width: 1rem;
                display: inline-block;
                margin-right: 0.25rem;
              "
            ></span>
            <sup class="text-xs">{{ portNumber }}</sup>
          </p>
        </div>

        <div
          class="row"
          v-if="onuStatus && rtlVsolData && rtlVsolData.ok && rtlVsolData.detail"
        >
          <div class="active_services">
            <!-- Basic Information from detail -->
            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">Serial Number</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlVsolData.detail?.sn || "N/A" }}
                </p>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">Vendor ID</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlVsolData.detail?.vendor_id || "N/A" }}
                </p>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">Equipment ID</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlVsolData.detail?.equipment_id || "N/A" }}
                </p>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">Software Version</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlVsolData.detail?.software_version || "N/A" }}
                </p>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">ONU Type</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlVsolData.detail?.onu_type || "N/A" }}
                </p>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">Admin Status</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlVsolData.detail?.admin_status || "N/A" }}
                </p>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">Operate Status</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlVsolData.detail?.operate_status || "N/A" }}
                </p>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">Model</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlVsolData.detail?.model || "N/A" }}
                </p>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">Version</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlVsolData.detail?.version || "N/A" }}
                </p>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">Product Code</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlVsolData.detail?.product_code || "N/A" }}
                </p>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">Security Mode</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlVsolData.detail?.security_mode || "N/A" }}
                </p>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">OMCC Version</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlVsolData.detail?.omcc_version || "N/A" }}
                </p>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">Ethernet UNI</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlVsolData.detail?.ethernet_uni_number || "N/A" }}
                </p>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">GEM Ports</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlVsolData.detail?.gem_portNumber || "N/A" }}
                </p>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">TCONT Number</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlVsolData.detail?.tcont_number || "N/A" }}
                </p>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">IP Hosts</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlVsolData.detail?.ip_host_number || "N/A" }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-else>
          <Skalaton />
        </div>
      </div>

      <!-- Optical Information Card -->
      <div class="p-4 d-flex flex-column chart_row_two_card">
        <div
          class="w-100 d-flex align-items-center justify-content-center position-relative"
        >
          <DonutChart
            :chartData="donutchartDataMiddle"
            :donutchartOptions="chartOptions"
            chartWidth="300px"
            chartHeight="300px"
            cutoutSize="80%"
            centerText=""
          />
          <div class="centered_text_donought_chart">
            <p class="p-0 m-0 text-center" style="font-size: 20px">
              {{ rtlVsolData.opticalinfo?.rx_optical_level_onu || "N/A" }}
            </p>
            <p
              class="p-2 m-0 text-center text-xs"
              style="font-weight: 600; margin-top: -13px !important"
            >
              RX Optical Level (dBm)
            </p>
          </div>
        </div>

        <div
          class="d-flex flex-grow-1 align-items-center justify-content-center"
          style="height: 190px"
        >
          <div
            class="w-50 d-flex flex-column align-items-start"
            style="border-right: 1px solid #80808071; padding-right: 10px"
          >
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• Temperature:</strong
              >
              {{ rtlVsolData.opticalinfo?.temperature || "N/A" }} °C
            </p>
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important">• Distance:</strong>
              {{ rtlVsolData.opticalinfo?.distance || "N/A" }} m
            </p>
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• Laser Bias Current:</strong
              >
              {{ rtlVsolData.opticalinfo?.laser_bias_current || "N/A" }} mA
            </p>
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• Power Feed Voltage:</strong
              >
              {{ rtlVsolData.opticalinfo?.power_feed_voltage || "N/A" }} V
            </p>
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• RX Optical Level (OLT):</strong
              >
              {{ rtlVsolData.opticalinfo?.rx_optical_level_olt || "N/A" }}
              dBm
            </p>
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• TX Optical Level:</strong
              >
              {{ rtlVsolData.opticalinfo?.tx_optical_level || "N/A" }} dBm
            </p>
          </div>

          <div
            class="w-50 d-flex flex-column align-items-start"
            style="padding-left: 10px"
          >
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• Alarm Status:</strong
              >
              {{ rtlVsolData.opticalinfo?.alarm || "N/A" }}
            </p>
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important">• Interface:</strong>
              {{ rtlVsolData.opticalinfo?.interface || "N/A" }}
            </p>
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• GEM Block Length:</strong
              >
              {{ rtlVsolData.opticalinfo?.gem_blocklen || "N/A" }}
            </p>
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• ONU Response Time:</strong
              >
              {{ rtlVsolData.opticalinfo?.onu_response_time || "N/A" }} ms
            </p>
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• Total T-CONT:</strong
              >
              {{ rtlVsolData.opticalinfo?.total_t_cont_number || "N/A" }}
            </p>
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• Piggyback DBA Mode:</strong
              >
              {{ rtlVsolData.opticalinfo?.piggyback_dba_rpt_mode || "N/A" }}
            </p>
          </div>
        </div>
      </div>

      <!-- Additional Information Card -->
      <div class="p-4 chart_row_one_card">
        <div class="d-flex mt-3">
          <hr class="flex-grow-1 me-2" />
          <span style="font-size: 15px">Port & System Information</span>
          <hr class="flex-grow-1 ml-2" />
        </div>
        <div class="active_services mt-2">
          <div class="d-flex align-items-center">
            <div
              class="rounded"
              style="height: 50px; width: 50px; background-color: dimgrey"
            ></div>
            <div class="p-2">
              <p class="m-0">PON Interface</p>
              <p
                class="m-0"
                style="font-size: 14px; color: greenyellow !important"
              >
                {{ rtlVsolData.opticalinfo?.interface || "N/A" }}
              </p>
            </div>
          </div>

          <div class="d-flex align-items-center">
            <div
              class="rounded"
              style="height: 50px; width: 50px; background-color: dimgrey"
            ></div>
            <div class="p-2">
              <p class="m-0">PON ID / ONU ID</p>
              <p
                class="m-0"
                style="font-size: 14px; color: greenyellow !important"
              >
                {{ rtlVsolData.ponid }} / {{ rtlVsolData.onuid }}
              </p>
            </div>
          </div>

          <div class="d-flex align-items-center">
            <div
              class="rounded"
              style="height: 50px; width: 50px; background-color: dimgrey"
            ></div>
            <div class="p-2">
              <p class="m-0">OLT ID</p>
              <p
                class="m-0"
                style="font-size: 14px; color: greenyellow !important"
              >
                {{ rtlVsolData.oltid || "N/A" }}
              </p>
            </div>
          </div>

          <div class="d-flex align-items-center">
            <div
              class="rounded"
              style="height: 50px; width: 50px; background-color: dimgrey"
            ></div>
            <div class="p-2">
              <p class="m-0">Alarm Disable Interval</p>
              <p
                class="m-0"
                style="font-size: 14px; color: greenyellow !important"
              >
                {{ rtlVsolData.opticalinfo?.alarm_disable_interval || "N/A" }}
              </p>
            </div>
          </div>

          <div class="d-flex align-items-center">
            <div
              class="rounded"
              style="height: 50px; width: 50px; background-color: dimgrey"
            ></div>
            <div class="p-2">
              <p class="m-0">SD Threshold</p>
              <p
                class="m-0"
                style="font-size: 14px; color: greenyellow !important"
              >
                {{ rtlVsolData.opticalinfo?.sd_threshold || "N/A" }}
              </p>
            </div>
          </div>

          <div class="d-flex align-items-center">
            <div
              class="rounded"
              style="height: 50px; width: 50px; background-color: dimgrey"
            ></div>
            <div class="p-2">
              <p class="m-0">SF Threshold</p>
              <p
                class="m-0"
                style="font-size: 14px; color: greenyellow !important"
              >
                {{ rtlVsolData.opticalinfo?.sf_threshold || "N/A" }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- GPON CDATA-CLOUDE-V1 -->
    <div
      v-else-if="rtlGponCloudeData && Object.keys(rtlGponCloudeData).length > 0"
      class="chart_row_three text-white"
    >
      <!-- Basic Information Card -->
      <div class="p-4 chart_row_one_card">
        <div class="d-flex">
          <p
            class="text-center p-0 m-0"
            style="font-size: 25px; line-height: 80px"
          >
            GPON CDATA-CLOUDE-V1 ONU Status
            <span
              v-if="rtlGponCloudeData.RunningState === 0 || rtlGponCloudeData.Status === true"
              class="inline-block bg-success rounded-circle"
              style="
                height: 1rem;
                width: 1rem;
                display: inline-block;
                margin-right: 0.25rem;
              "
            ></span>
            <span
              v-else
              class="inline-block bg-danger rounded-circle"
              style="
                height: 1rem;
                width: 1rem;
                display: inline-block;
                margin-right: 0.25rem;
              "
            ></span>
            <sup class="text-xs">{{ portNumber }}</sup>
          </p>
        </div>

        <div
          class="row"
          v-if="onuStatus && rtlGponCloudeData && Object.keys(rtlGponCloudeData).length > 0"
        >
          <div class="active_services">
            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">ONU ID</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlGponCloudeData.OnuId || "N/A" }}
                </p>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">ONU Name</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlGponCloudeData.OnuName || "N/A" }}
                </p>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">PON ID</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlGponCloudeData.PonId || "N/A" }}
                </p>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">PON Serial Number</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlGponCloudeData.PonSn || "N/A" }}
                </p>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">ONU Description</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlGponCloudeData.OnuDesc || "N/A" }}
                </p>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">Running State</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ getRunningStateText(rtlGponCloudeData.RunningState) }}
                </p>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">Status</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlGponCloudeData.Status ? 'Online' : 'Offline' }}
                </p>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">Config State</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlGponCloudeData.ConfigState !== undefined ? rtlGponCloudeData.ConfigState : "N/A" }}
                </p>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">ONU Type</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlGponCloudeData.OnuType || "N/A" }}
                </p>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">Vendor ID</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlGponCloudeData.VendorId || "N/A" }}
                </p>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">Hardware Version</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlGponCloudeData.HwVersion || "N/A" }}
                </p>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">Software Version</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlGponCloudeData.SwVersion || "N/A" }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-else>
          <Skalaton />
        </div>
      </div>

      <!-- Optical Information Card -->
      <div class="p-4 d-flex flex-column chart_row_two_card">
        <div
          class="w-100 d-flex align-items-center justify-content-center position-relative"
        >
          <DonutChart
            :chartData="donutchartDataMiddle"
            :donutchartOptions="chartOptions"
            chartWidth="300px"
            chartHeight="300px"
            cutoutSize="80%"
            centerText=""
          />
          <div class="centered_text_donought_chart">
            <p class="p-0 m-0 text-center" style="font-size: 20px">
              {{ rtlGponCloudeData.RxPower !== null && rtlGponCloudeData.RxPower !== undefined && rtlGponCloudeData.RxPower !== 0 ? rtlGponCloudeData.RxPower : (description || "N/A") }}
            </p>
            <p
              class="p-2 m-0 text-center text-xs"
              style="font-weight: 600; margin-top: -13px !important"
            >
              RX Power (dBm)
            </p>
          </div>
        </div>

        <div
          class="d-flex flex-grow-1 align-items-center justify-content-center"
          style="height: 190px"
        >
          <div
            class="w-50 d-flex flex-column align-items-start"
            style="border-right: 1px solid #80808071; padding-right: 10px"
          >
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• Temperature:</strong
              >
              {{ rtlGponCloudeData.Temperature !== null && rtlGponCloudeData.Temperature !== undefined && rtlGponCloudeData.Temperature !== 0 ? rtlGponCloudeData.Temperature + ' °C' : (temperatureOnu || "N/A") }}
            </p>
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important">• Voltage:</strong>
              {{ rtlGponCloudeData.Voltage !== null && rtlGponCloudeData.Voltage !== undefined && rtlGponCloudeData.Voltage !== 0 ? rtlGponCloudeData.Voltage + ' V' : "N/A" }}
            </p>
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• Bias Current:</strong
              >
              {{ rtlGponCloudeData.BiasCurrent !== null && rtlGponCloudeData.BiasCurrent !== undefined && rtlGponCloudeData.BiasCurrent !== 0 ? rtlGponCloudeData.BiasCurrent + ' mA' : "N/A" }}
            </p>
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• TX Power:</strong
              >
              {{ rtlGponCloudeData.TxPower !== null && rtlGponCloudeData.TxPower !== undefined && rtlGponCloudeData.TxPower !== 0 ? rtlGponCloudeData.TxPower + ' dBm' : "N/A" }}
            </p>
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• RX Rate:</strong
              >
              {{ rtlGponCloudeData.RXRate !== null && rtlGponCloudeData.RXRate !== undefined && rtlGponCloudeData.RXRate !== 0 ? formatRate(rtlGponCloudeData.RXRate) : "N/A" }}
            </p>
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• TX Rate:</strong
              >
              {{ rtlGponCloudeData.TXRate !== null && rtlGponCloudeData.TXRate !== undefined && rtlGponCloudeData.TXRate !== 0 ? formatRate(rtlGponCloudeData.TXRate) : "N/A" }}
            </p>
          </div>

          <div
            class="w-50 d-flex flex-column align-items-start"
            style="padding-left: 10px"
          >
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• Last Disconnect Reason:</strong
              >
              <br />
              {{ lastDeregReason || getLastDownCause(rtlGponCloudeData.LastDownCause) || "N/A" }}
            </p>
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• Running Time:</strong
              >
              {{ rtlGponCloudeData.RunningTime !== null && rtlGponCloudeData.RunningTime !== undefined && rtlGponCloudeData.RunningTime !== 0 ? formatRunningTime(rtlGponCloudeData.RunningTime) : "N/A" }}
            </p>
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• Range:</strong
              >
              {{ rtlGponCloudeData.Range !== null && rtlGponCloudeData.Range !== undefined && rtlGponCloudeData.Range !== 0 ? rtlGponCloudeData.Range + ' m' : "N/A" }}
            </p>
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• Ethernet Ports:</strong
              >
              {{ rtlGponCloudeData.EthNum !== null && rtlGponCloudeData.EthNum !== undefined ? rtlGponCloudeData.EthNum : "N/A" }}
            </p>
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• POTS Ports:</strong
              >
              {{ rtlGponCloudeData.PotsNum !== null && rtlGponCloudeData.PotsNum !== undefined ? rtlGponCloudeData.PotsNum : "N/A" }}
            </p>
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• WiFi:</strong
              >
              {{ rtlGponCloudeData.Wifi !== null && rtlGponCloudeData.Wifi !== undefined ? (rtlGponCloudeData.Wifi ? 'Yes' : 'No') : "N/A" }}
            </p>
          </div>
        </div>
      </div>

      <!-- Additional Information Card -->
      <div class="p-4 chart_row_one_card">
        <div class="d-flex mt-3">
          <hr class="flex-grow-1 me-2" />
          <span style="font-size: 15px">Profile & Configuration</span>
          <hr class="flex-grow-1 ml-2" />
        </div>
        <div class="active_services mt-2">
          <div class="d-flex align-items-center">
            <div
              class="rounded"
              style="height: 50px; width: 50px; background-color: dimgrey"
            ></div>
            <div class="p-2">
              <p class="m-0">Line Profile</p>
              <p
                class="m-0"
                style="font-size: 14px; color: greenyellow !important"
              >
                {{ rtlGponCloudeData.LineProfileName || "N/A" }}
              </p>
            </div>
          </div>

          <div class="d-flex align-items-center">
            <div
              class="rounded"
              style="height: 50px; width: 50px; background-color: dimgrey"
            ></div>
            <div class="p-2">
              <p class="m-0">Service Profile</p>
              <p
                class="m-0"
                style="font-size: 14px; color: greenyellow !important"
              >
                {{ rtlGponCloudeData.SrvProfileName || "N/A" }}
              </p>
            </div>
          </div>

          <div class="d-flex align-items-center">
            <div
              class="rounded"
              style="height: 50px; width: 50px; background-color: dimgrey"
            ></div>
            <div class="p-2">
              <p class="m-0">Multi-Service Profile</p>
              <p
                class="m-0"
                style="font-size: 14px; color: greenyellow !important"
              >
                {{ rtlGponCloudeData.MultSrvPrfName || "N/A" }}
              </p>
            </div>
          </div>

          <div class="d-flex align-items-center">
            <div
              class="rounded"
              style="height: 50px; width: 50px; background-color: dimgrey"
            ></div>
            <div class="p-2">
              <p class="m-0">WAN Profile</p>
              <p
                class="m-0"
                style="font-size: 14px; color: greenyellow !important"
              >
                {{ rtlGponCloudeData.WanProfileName || "N/A" }}
              </p>
            </div>
          </div>

          <div class="d-flex align-items-center">
            <div
              class="rounded"
              style="height: 50px; width: 50px; background-color: dimgrey"
            ></div>
            <div class="p-2">
              <p class="m-0">TR069 Profile</p>
              <p
                class="m-0"
                style="font-size: 14px; color: greenyellow !important"
              >
                {{ rtlGponCloudeData.TR069ProfileName || "N/A" }}
              </p>
            </div>
          </div>

          <div class="d-flex align-items-center">
            <div
              class="rounded"
              style="height: 50px; width: 50px; background-color: dimgrey"
            ></div>
            <div class="p-2">
              <p class="m-0">OMCC</p>
              <p
                class="m-0"
                style="font-size: 14px; color: greenyellow !important"
              >
                {{ rtlGponCloudeData.Omcc || "N/A" }}
              </p>
            </div>
          </div>

          <div class="d-flex align-items-center">
            <div
              class="rounded"
              style="height: 50px; width: 50px; background-color: dimgrey"
            ></div>
            <div class="p-2">
              <p class="m-0">Match State</p>
              <p
                class="m-0"
                style="font-size: 14px; color: greenyellow !important"
              >
                {{ rtlGponCloudeData.MatchState !== undefined ? rtlGponCloudeData.MatchState : "N/A" }}
              </p>
            </div>
          </div>

          <div class="d-flex align-items-center">
            <div
              class="rounded"
              style="height: 50px; width: 50px; background-color: dimgrey"
            ></div>
            <div class="p-2">
              <p class="m-0">Control Flag</p>
              <p
                class="m-0"
                style="font-size: 14px; color: greenyellow !important"
              >
                {{ rtlGponCloudeData.ControlFlag !== undefined ? rtlGponCloudeData.ControlFlag : "N/A" }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- VSOL EPON -->
    <div
      v-else-if="rtlVsolData && rtlVsolData.single_onudata"
      class="chart_row_three text-white"
    >
      <!-- Basic Information Card -->
      <div class="p-4 chart_row_one_card">
        <div class="d-flex">
          <p
            class="text-center p-0 m-0"
            style="font-size: 25px; line-height: 80px"
          >
            VSOL EPON ONU Status
            <span
              v-if="rtlVsolData.single_onudata.status === 'Online'"
              class="inline-block bg-success rounded-circle"
              style="
                height: 1rem;
                width: 1rem;
                display: inline-block;
                margin-right: 0.25rem;
              "
            ></span>
            <span
              v-else
              class="inline-block bg-danger rounded-circle"
              style="
                height: 1rem;
                width: 1rem;
                display: inline-block;
                margin-right: 0.25rem;
              "
            ></span>
            <sup class="text-xs">{{ portNumber }}</sup>
          </p>
        </div>

        <div
          class="row"
          v-if="onuStatus && rtlVsolData && rtlVsolData.single_onudata"
        >
          <div class="active_services">
            <!-- Basic Information from single_onudata -->
            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">Status</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlVsolData.single_onudata.status || "N/A" }}
                </p>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">ONU ID</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlVsolData.single_onudata.onu_id || "N/A" }}
                </p>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">MAC Address</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlVsolData.single_onudata.mac_address || "N/A" }}
                </p>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">Distance</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlVsolData.single_onudata.distance_m || "N/A" }} m
                </p>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">Alive Time</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlVsolData.single_onudata.alive_time || "N/A" }}
                </p>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">Last Register Time</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlVsolData.single_onudata.last_register_time || "N/A" }}
                </p>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">Last Deregister Time</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{
                    rtlVsolData.single_onudata.last_deregister_time || "N/A"
                  }}
                </p>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">Deregister Detail</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlVsolData.single_onudata.deregister_detail || "N/A" }}
                </p>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">RTT TQ</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlVsolData.single_onudata.rtt_tq || "N/A" }}
                </p>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">Upgrade Status</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlVsolData.single_onudata.upgrade || "N/A" }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-else>
          <Skalaton />
        </div>
      </div>

      <!-- Middle Card with Donut Chart -->
      <div class="p-4 d-flex flex-column chart_row_two_card">
        <div
          class="w-100 d-flex align-items-center justify-content-center position-relative"
        >
          <DonutChart
            :chartData="donutchartDataMiddle"
            :donutchartOptions="chartOptions"
            chartWidth="300px"
            chartHeight="300px"
            cutoutSize="80%"
            centerText=""
          />
          <div class="centered_text_donought_chart">
            <p class="p-0 m-0 text-center" style="font-size: 20px">
              {{ rtlVsolData.single_onudata.distance_m || "N/A" }}
            </p>
            <p
              class="p-2 m-0 text-center text-xs"
              style="font-weight: 600; margin-top: -13px !important"
            >
              Distance (m)
            </p>
          </div>
        </div>

        <div
          class="d-flex flex-grow-1 align-items-center justify-content-center"
          style="height: 190px"
        >
          <div
            class="w-50 d-flex flex-column align-items-start"
            style="border-right: 1px solid #80808071; padding-right: 10px"
          >
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• Alive Time:</strong
              >
              {{ rtlVsolData.single_onudata.alive_time || "N/A" }}
            </p>
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• Last Register:</strong
              >
              {{ rtlVsolData.single_onudata.last_register_time || "N/A" }}
            </p>
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important">• RTT TQ:</strong>
              {{ rtlVsolData.single_onudata.rtt_tq || "N/A" }}
            </p>
          </div>

          <div
            class="w-50 d-flex flex-column align-items-start"
            style="padding-left: 10px"
          >
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• Last Deregister:</strong
              >
              {{ rtlVsolData.single_onudata.last_deregister_time || "N/A" }}
            </p>
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• Deregister Detail:</strong
              >
              {{ rtlVsolData.single_onudata.deregister_detail || "N/A" }}
            </p>
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• Upgrade Status:</strong
              >
              {{ rtlVsolData.single_onudata.upgrade || "N/A" }}
            </p>
          </div>
        </div>
      </div>

      <!-- Additional Information Card -->
      <div class="p-4 chart_row_one_card">
        <div class="d-flex mt-3">
          <hr class="flex-grow-1 me-2" />
          <span style="font-size: 15px">Connection Information</span>
          <hr class="flex-grow-1 ml-2" />
        </div>
        <div class="active_services mt-2">
          <div class="d-flex align-items-center">
            <div
              class="rounded"
              style="height: 50px; width: 50px; background-color: dimgrey"
            ></div>
            <div class="p-2">
              <p class="m-0">ONU Interface</p>
              <p
                class="m-0"
                style="font-size: 14px; color: greenyellow !important"
              >
                {{ rtlVsolData.single_onudata.onu_id || "N/A" }}
              </p>
            </div>
          </div>

          <div class="d-flex align-items-center">
            <div
              class="rounded"
              style="height: 50px; width: 50px; background-color: dimgrey"
            ></div>
            <div class="p-2">
              <p class="m-0">Connection Status</p>
              <p
                class="m-0"
                style="font-size: 14px; color: greenyellow !important"
              >
                {{ rtlVsolData.single_onudata.status || "N/A" }}
              </p>
            </div>
          </div>

          <div class="d-flex align-items-center">
            <div
              class="rounded"
              style="height: 50px; width: 50px; background-color: dimgrey"
            ></div>
            <div class="p-2">
              <p class="m-0">Signal Quality</p>
              <p
                class="m-0"
                style="font-size: 14px; color: greenyellow !important"
              >
                Distance: {{ rtlVsolData.single_onudata.distance_m || "N/A" }}m
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- TBS EPON -->
    <div
      v-else-if="onuStatus && rtlTbsEponData && rtlTbsEponData.data && Object.keys(rtlTbsEponData.data).length > 0"
      class="chart_row_two text-white"
    >
      <!-- First Card with ONU Information -->
      <div class="p-4 chart_row_one_card">
        <div class="d-flex">
          <p
            class="text-center p-0 m-0"
            style="font-size: 25px; line-height: 80px"
          >
            Total Onu Status
            <span
              v-if="rtlTbsEponData.data && rtlTbsEponData.data.getPortOnuOpticalOne && rtlTbsEponData.data.getPortOnuOpticalOne.rxpower"
              class="inline-block bg-success rounded-circle"
              style="
                height: 1rem;
                width: 1rem;
                display: inline-block;
                margin-right: 0.25rem;
              "
            ></span>
            <span
              v-else
              class="inline-block bg-danger rounded-circle"
              style="
                height: 1rem;
                width: 1rem;
                display: inline-block;
                margin-right: 0.25rem;
              "
            ></span>
            <sup class="text-xs">{{ portNumber }}</sup>
          </p>
        </div>

        <div
          class="row"
          v-if="onuStatus && rtlTbsEponData && rtlTbsEponData.data"
        >
          <div class="active_services">
            <!-- Optical Information -->
            <div
              v-if="rtlTbsEponData.data.getPortOnuOpticalOne"
              class="d-flex align-items-center"
            >
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">RX Power</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlTbsEponData.data.getPortOnuOpticalOne.rxpower || "N/A" }} dBm
                </p>
              </div>
            </div>

            <div
              v-if="rtlTbsEponData.data.getPortOnuOpticalOne"
              class="d-flex align-items-center"
            >
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">TX Power</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlTbsEponData.data.getPortOnuOpticalOne.txpower || "N/A" }} dBm
                </p>
              </div>
            </div>

            <div
              v-if="rtlTbsEponData.data.getPortOnuOpticalOne"
              class="d-flex align-items-center"
            >
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">Temperature</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlTbsEponData.data.getPortOnuOpticalOne.temp || "N/A" }} °C
                </p>
              </div>
            </div>

            <div
              v-if="rtlTbsEponData.data.getPortOnuOpticalOne"
              class="d-flex align-items-center"
            >
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">Voltage</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlTbsEponData.data.getPortOnuOpticalOne.vol || "N/A" }} V
                </p>
              </div>
            </div>

            <div
              v-if="rtlTbsEponData.data.getPortOnuOpticalOne"
              class="d-flex align-items-center"
            >
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">Bias Current</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlTbsEponData.data.getPortOnuOpticalOne.bias || "N/A" }} mA
                </p>
              </div>
            </div>

            <div
              v-if="rtlTbsEponData.data.getPortOnuOpticalOne"
              class="d-flex align-items-center"
            >
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">Distance</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlTbsEponData.data.getPortOnuOpticalOne.distance || "N/A" }} m
                </p>
              </div>
            </div>

            <!-- Capability Information -->
            <div
              v-if="rtlTbsEponData.data.getPortOnuCapOne"
              class="d-flex align-items-center"
            >
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">MAC Address</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlTbsEponData.data.getPortOnuCapOne.mac || "N/A" }}
                </p>
              </div>
            </div>

            <div
              v-if="rtlTbsEponData.data.getPortOnuCapOne"
              class="d-flex align-items-center"
            >
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">ONU Type</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlTbsEponData.data.getPortOnuCapOne.onutype || "N/A" }}
                </p>
              </div>
            </div>

            <div
              v-if="rtlTbsEponData.data.getPortOnuCapOne"
              class="d-flex align-items-center"
            >
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">Description</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlTbsEponData.data.getPortOnuCapOne.desc || "N/A" }}
                </p>
              </div>
            </div>

            <!-- Version Information -->
            <div
              v-if="rtlTbsEponData.data.getPortOnuVerOne"
              class="d-flex align-items-center"
            >
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">Software Version</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlTbsEponData.data.getPortOnuVerOne.software || "N/A" }}
                </p>
              </div>
            </div>

            <div
              v-if="rtlTbsEponData.data.getPortOnuVerOne"
              class="d-flex align-items-center"
            >
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">Hardware Version</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlTbsEponData.data.getPortOnuVerOne.hardware || "N/A" }}
                </p>
              </div>
            </div>

            <div
              v-if="rtlTbsEponData.data.getPortOnuVerOne"
              class="d-flex align-items-center"
            >
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">Vendor</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlTbsEponData.data.getPortOnuVerOne.vendor || "N/A" }}
                </p>
              </div>
            </div>

            <div
              v-if="rtlTbsEponData.data.getPortOnuVerOne"
              class="d-flex align-items-center"
            >
              <div
                class="rounded"
                style="height: 50px; width: 50px; background-color: dimgrey"
              ></div>
              <div class="p-2">
                <p class="m-0">Model</p>
                <p
                  class="m-0"
                  style="font-size: 14px; color: greenyellow !important"
                >
                  {{ rtlTbsEponData.data.getPortOnuVerOne.model || "N/A" }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-else>
          <Skalaton />
        </div>
      </div>

      <!-- Middle Card with Donut Chart -->
      <div class="p-4 d-flex flex-column chart_row_two_card">
        <div
          class="w-100 d-flex align-items-center justify-content-center position-relative"
        >
          <DonutChart
            :chartData="donutchartDataMiddle"
            :donutchartOptions="chartOptions"
            chartWidth="300px"
            chartHeight="300px"
            cutoutSize="80%"
            centerText=""
          />
          <div class="centered_text_donought_chart">
            <p class="p-0 m-0 text-center" style="font-size: 20px">
              {{ rtlTbsEponData.data && rtlTbsEponData.data.getPortOnuOpticalOne ? (rtlTbsEponData.data.getPortOnuOpticalOne.distance || "N/A") : "N/A" }}
            </p>
            <p
              class="p-2 m-0 text-center text-xs"
              style="font-weight: 600; margin-top: -13px !important"
            >
              Distance (m)
            </p>
          </div>
        </div>

        <div
          class="d-flex flex-grow-1 align-items-center justify-content-center"
          style="height: 190px"
        >
          <div
            class="w-50 d-flex flex-column align-items-start"
            style="border-right: 1px solid #80808071; padding-right: 10px"
          >
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• Temperature:</strong
              >
              {{ rtlTbsEponData.data && rtlTbsEponData.data.getPortOnuOpticalOne ? (rtlTbsEponData.data.getPortOnuOpticalOne.temp || "N/A") + " °C" : (temperatureOnu || "N/A") }}
            </p>
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important">• Voltage:</strong>
              {{ rtlTbsEponData.data && rtlTbsEponData.data.getPortOnuOpticalOne ? (rtlTbsEponData.data.getPortOnuOpticalOne.vol || "N/A") + " V" : "N/A" }}
            </p>
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• Bias Current:</strong
              >
              {{ rtlTbsEponData.data && rtlTbsEponData.data.getPortOnuOpticalOne ? (rtlTbsEponData.data.getPortOnuOpticalOne.bias || "N/A") + " mA" : "N/A" }}
            </p>
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• TX Power:</strong
              >
              {{ rtlTbsEponData.data && rtlTbsEponData.data.getPortOnuOpticalOne ? (rtlTbsEponData.data.getPortOnuOpticalOne.txpower || "N/A") + " dBm" : "N/A" }}
            </p>
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• RX Power:</strong
              >
              {{ rtlTbsEponData.data && rtlTbsEponData.data.getPortOnuOpticalOne ? (rtlTbsEponData.data.getPortOnuOpticalOne.rxpower || "N/A") + " dBm" : "N/A" }}
            </p>
          </div>

          <div
            class="w-50 d-flex flex-column align-items-start"
            style="padding-left: 10px"
          >
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• ONU ID:</strong
              >
              {{ rtlTbsEponData.data && rtlTbsEponData.data.getPortOnuOpticalOne ? (rtlTbsEponData.data.getPortOnuOpticalOne.onuId || "N/A") : "N/A" }}
            </p>
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• Port Name:</strong
              >
              {{ rtlTbsEponData.data && rtlTbsEponData.data.getPortOnuOpticalOne ? (rtlTbsEponData.data.getPortOnuOpticalOne.portName || "N/A") : "N/A" }}
            </p>
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• Distance:</strong
              >
              {{ rtlTbsEponData.data && rtlTbsEponData.data.getPortOnuOpticalOne ? (rtlTbsEponData.data.getPortOnuOpticalOne.distance || "N/A") + " m" : "N/A" }}
            </p>
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• ONU Type:</strong
              >
              {{ rtlTbsEponData.data && rtlTbsEponData.data.getPortOnuCapOne ? (rtlTbsEponData.data.getPortOnuCapOne.onutype || "N/A") : "N/A" }}
            </p>
            <p
              class="text-center p-0 m-1"
              style="font-size: 14px; font-weight: 600"
            >
              <strong style="color: greenyellow !important"
                >• Software:</strong
              >
              {{ rtlTbsEponData.data && rtlTbsEponData.data.getPortOnuVerOne ? (rtlTbsEponData.data.getPortOnuVerOne.software || "N/A") : "N/A" }}
            </p>
          </div>
        </div>
      </div>

      <!-- Additional Information Card -->
      <div class="p-4 chart_row_one_card">
        <div class="d-flex mt-3">
          <hr class="flex-grow-1 me-2" />
          <span style="font-size: 15px">Device Information</span>
          <hr class="flex-grow-1 ml-2" />
        </div>
        <div class="active_services mt-2">
          <div class="d-flex align-items-center">
            <div
              class="rounded"
              style="height: 50px; width: 50px; background-color: dimgrey"
            ></div>
            <div class="p-2">
              <p class="m-0">MAC Address</p>
              <p
                class="m-0"
                style="font-size: 14px; color: greenyellow !important"
              >
                {{ rtlTbsEponData.data && rtlTbsEponData.data.getPortOnuOpticalOne ? (rtlTbsEponData.data.getPortOnuOpticalOne.mac || "N/A") : "N/A" }}
              </p>
            </div>
          </div>

          <div class="d-flex align-items-center">
            <div
              class="rounded"
              style="height: 50px; width: 50px; background-color: dimgrey"
            ></div>
            <div class="p-2">
              <p class="m-0">Vendor</p>
              <p
                class="m-0"
                style="font-size: 14px; color: greenyellow !important"
              >
                {{ rtlTbsEponData.data && rtlTbsEponData.data.getPortOnuVerOne ? (rtlTbsEponData.data.getPortOnuVerOne.vendor || "N/A") : "N/A" }}
              </p>
            </div>
          </div>

          <div class="d-flex align-items-center">
            <div
              class="rounded"
              style="height: 50px; width: 50px; background-color: dimgrey"
            ></div>
            <div class="p-2">
              <p class="m-0">Model</p>
              <p
                class="m-0"
                style="font-size: 14px; color: greenyellow !important"
              >
                {{ rtlTbsEponData.data && rtlTbsEponData.data.getPortOnuVerOne ? (rtlTbsEponData.data.getPortOnuVerOne.model || "N/A") : "N/A" }}
              </p>
            </div>
          </div>

          <div class="d-flex align-items-center">
            <div
              class="rounded"
              style="height: 50px; width: 50px; background-color: dimgrey"
            ></div>
            <div class="p-2">
              <p class="m-0">Hardware Version</p>
              <p
                class="m-0"
                style="font-size: 14px; color: greenyellow !important"
              >
                {{ rtlTbsEponData.data && rtlTbsEponData.data.getPortOnuVerOne ? (rtlTbsEponData.data.getPortOnuVerOne.hardware || "N/A") : "N/A" }}
              </p>
            </div>
          </div>
        </div>
      </div>

     
    </div>

    <!-- Loading State -->
    <div v-else>
      <Skalatonloader />
    </div>
  </div>
</template>

<script>
import DonutChart from "@/examples/Charts/DonutChart.vue";
import Skalaton from "@/components/Skalaton.vue";
import Skalatonloader from "@/components/Skalatonloader.vue";
import EponClodeOnuStatus from "@/views/components/EponClodeOnuStatus.vue";

export default {
  name: "OnuRealtimeTab",
  components: {
    DonutChart,
    Skalaton,
    Skalatonloader,
    EponClodeOnuStatus,
  },
  props: {
    rtlData: {
      type: Object,
      default: () => ({}),
    },
    rtlEponData: {
      type: Object,
      default: () => ({}),
    },
    rtlCdataData: {
      type: Object,
      default: () => ({}),
    },
    rtlCloudeData: {
      type: Object,
      default: () => ({}),
    },
    rtlVsolData: {
      type: Object,
      default: () => ({}),
    },
    rtlBdcomEponData: {
      type: Object,
      default: () => ({}),
    },
    rtlGponCloudeData: {
      type: Object,
      default: () => ({}),
    },
    rtlTbsEponData: {
      type: Object,
      default: () => ({}),
    },
    onuStatus: {
      type: Boolean,
      default: false,
    },
    onuRealtimeLoader: {
      type: Boolean,
      default: false,
    },
    portNumber: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    temperatureOnu: {
      type: String,
      default: "",
    },
    lastDeregReason: {
      type: String,
      default: "",
    },
    donutchartData: {
      type: Object,
      default: () => ({}),
    },
    donutchartDataMiddle: {
      type: Object,
      default: () => ({}),
    },
    chartOptions: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["logs-popup-open"],
  computed: {
    filteredBdcomEponData() {
      if (!this.rtlBdcomEponData) {
        return [];
      }
      
      // If we have interfaceData (array of objects), use EPON interfaces or first interface
      if (this.rtlBdcomEponData.interfaceData && this.rtlBdcomEponData.interfaceData.length > 0) {
        // Find all EPON interfaces, prefer connected ones
        const eponInterfaces = this.rtlBdcomEponData.interfaceData.filter(item => 
          item.Interface && item.Interface.toLowerCase().includes('epon')
        );
        
        // Use first connected EPON interface, or first EPON interface, or first interface
        const selectedInterface = eponInterfaces.find(item => 
          item['Connection state'] && item['Connection state'].toLowerCase() === 'connect'
        ) || eponInterfaces[0] || this.rtlBdcomEponData.interfaceData[0];
        
        if (selectedInterface) {
          return Object.entries(selectedInterface)
            .filter(([key, value]) => {
              return value !== null && 
                     value !== undefined && 
                     value !== '' && 
                     value !== 'N/A' && 
                     value !== '---' &&
                     !key.toLowerCase().includes('config');
            })
            .map(([key, value]) => ({
              key,
              value: typeof value === 'string' ? value : String(value)
            }));
        }
      }
      
      // Otherwise use parsedData (object with key-value pairs)
      if (this.rtlBdcomEponData.parsedData && Object.keys(this.rtlBdcomEponData.parsedData).length > 0) {
        return Object.entries(this.rtlBdcomEponData.parsedData)
          .filter(([key, value]) => {
            return value !== null &&
                   value !== undefined &&
                   value !== '' && 
                   value !== 'N/A' && 
                   value !== '---' &&
                   !key.toLowerCase().includes('config') &&
                   (typeof value !== 'string' || !value.includes('8_PORT_BDCOM_OLT'));
          })
          .map(([key, value]) => ({
            key,
            value: typeof value === 'string' ? value : String(value)
          }));
      }
      
      // If we have raw data array but no parsed data, try to parse it
      if (this.rtlBdcomEponData.data && Array.isArray(this.rtlBdcomEponData.data) && this.rtlBdcomEponData.data.length > 0) {
        const firstItem = this.rtlBdcomEponData.data[0];
        if (typeof firstItem === 'object' && firstItem !== null) {
          return Object.entries(firstItem)
            .filter(([key, value]) => {
              return value !== null && 
                     value !== undefined && 
                     value !== '' && 
                     value !== 'N/A' && 
                     value !== '---' &&
                     !key.toLowerCase().includes('config');
            })
            .map(([key, value]) => ({
              key,
              value: typeof value === 'string' ? value : String(value)
            }));
        }
      }
      
      return [];
    },
  },
  methods: {
    getParsedValue(parsedData, key) {
      if (!parsedData) return null;
      // Try exact match first
      if (parsedData[key]) return parsedData[key];
      // Try case-insensitive match
      const foundKey = Object.keys(parsedData).find(
        k => k.toLowerCase().trim() === key.toLowerCase().trim()
      );
      return foundKey ? parsedData[foundKey] : null;
    },
    getReceivedPower(rtlBdcomEponData) {
      if (!rtlBdcomEponData) return null;
      
      // Try different keys for received power
      const rxPowerKeys = ['received power(DBm)', 'Received Power', 'Rx Power', 'receive_power'];
      
      // Check in parsedData first
      if (rtlBdcomEponData.parsedData) {
        for (const key of rxPowerKeys) {
          if (rtlBdcomEponData.parsedData[key]) {
            return rtlBdcomEponData.parsedData[key];
          }
        }
      }
      
      // Check in interfaceData
      if (rtlBdcomEponData.interfaceData && rtlBdcomEponData.interfaceData.length > 0) {
        const eponInterface = rtlBdcomEponData.interfaceData.find(item => 
          item.Interface && item.Interface.toLowerCase().includes('epon')
        );
        if (eponInterface) {
          for (const key of rxPowerKeys) {
            if (eponInterface[key]) {
              return eponInterface[key];
            }
          }
        }
      }
      
      return null;
    },
    getRunningStateText(state) {
      const stateMap = {
        0: 'Online',
        1: 'Offline',
        2: 'Initializing',
        3: 'Failed'
      };
      return stateMap[state] || 'Unknown';
    },
    getLastDownCause(cause) {
      if (cause === null || cause === undefined || cause === 0) return null;
      // Common GPON down causes
      const causeMap = {
        1: 'LOSi (Loss of Signal)',
        2: 'LOAi (Loss of Alignment)',
        3: 'LOAMi (Loss of PLOAM)',
        4: 'RDIi (Remote Defect Indication)',
        5: 'SF (Signal Fail)',
        6: 'SD (Signal Degrade)',
        7: 'SUFi (Startup Failure)',
        8: 'Dying Gasp',
        9: 'Deactivate ONU',
        10: 'Disable ONU'
      };
      return causeMap[cause] || `Cause ${cause}`;
    },
    formatRunningTime(seconds) {
      if (!seconds || seconds === 0) return 'N/A';
      const days = Math.floor(seconds / (24 * 60 * 60));
      const hours = Math.floor((seconds % (24 * 60 * 60)) / (60 * 60));
      const minutes = Math.floor((seconds % (60 * 60)) / 60);
      if (days > 0) {
        return `${days}d ${hours}h ${minutes}m`;
      } else if (hours > 0) {
        return `${hours}h ${minutes}m`;
      } else {
        return `${minutes}m`;
      }
    },
    formatRate(rate) {
      if (!rate || rate === 0) return 'N/A';
      if (rate >= 1000000000) {
        return (rate / 1000000000).toFixed(2) + ' Gbps';
      } else if (rate >= 1000000) {
        return (rate / 1000000).toFixed(2) + ' Mbps';
      } else if (rate >= 1000) {
        return (rate / 1000).toFixed(2) + ' Kbps';
      }
      return rate + ' bps';
    },
  },
};
</script>

